import React from "react";

import CustomerDetails from "@/pages/PledgeConsentApproval/components/CustomerDetails";
import PledgeDetails from "@/pages/PledgeConsentApproval/components/PledgeDetails";
import { PledgeBatch } from "@/types/pledgeService";

import styles from "./ConsentDetails.module.css";

interface Props {
  pledgeBatch: PledgeBatch;
  actionType: string;
}
const ConsentDetails: React.FC<Props> = ({ pledgeBatch, actionType }) => {
  return (
    <div className={styles.container}>
      {/* <div
        className={`${styles.customerGrid} ${
          pledgeBatch?.pledges?.[0]?.customer && pledgeBatch?.pledges?.[0]?.owner
            ? styles.customerGridWithOwner
            : styles.customerGridWithoutOwner
        }`}
      >
        <CustomerDetails details={pledgeBatch?.pledges?.[0]?.customer} variant="customerConsent" />
        {pledgeBatch?.pledges?.[0]?.owner && (
          <CustomerDetails details={pledgeBatch?.pledges?.[0]?.owner} variant="customerConsent" />
        )}
      </div> */}
      <div className={styles.pledgeGrid}>
        {pledgeBatch?.pledges?.map((pledge, index) => (
          <PledgeDetails
            pledge={pledge}
            index={index}
            actionType={actionType}
            variant="customerConsent"
          />
        ))}
      </div>
    </div>
  );
};

export default ConsentDetails;
